import { type AxiosRequestConfig } from 'axios'

const updateUserOrganization = (data: any): AxiosRequestConfig => {
  return {
    method: 'Post',
    url: '/user/info/organization',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
}

export { updateUserOrganization}